import React from 'react';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  root: {
    position:'absolute',
    top:0,
    left:0,
    bottom:0,
    flex:1,
  },
  dataBackground: {
    background: '#f8f8f8'
  },
  loader: {
    color: theme.palette.hylyBlue
  }
});

const Loader = ({
  classes: {
    root,
    loader
  },
}) => {

  return (
    <Grid
      container
      className = { root }//classes.margin }
      direction  ='column'
      justify    = 'center'
      alignItems ='center'
    >
    <CircularProgress className = {loader} color="primary" />
  </Grid>
  );
}


export default withStyles(styles)(Loader);
